const PNP_REFRESH_V1 = 'GROW-2792';
const TYPE_DESCRIPTION = '[Type: String][Vis.: high] - ';
const EXPERIMENT_DESCRIPTION = ' - A string in pricing experiment GROW-2792';
const CATEGORY = 'IPPM';

const IPPM_DRAFT_COPY = {
  ALSO_INCLUDED_IN: {
    id: 'Pricing.experimentIPPMCopy.AlsoIncludedIn',
    defaultMessage: 'Also included in {package}',
    desc: {
      id: 'Pricing.experimentIPPMCopy.AlsoIncludedIn',
      message: `${TYPE_DESCRIPTION} ${CATEGORY} label ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
  INCLUDED_IN: {
    id: 'Pricing.experimentIPPMCopy.IncludedIn',
    defaultMessage: 'Included in {package}',
    desc: {
      id: 'Pricing.experimentIPPMCopy.IncludedIn',
      message: `${TYPE_DESCRIPTION} ${CATEGORY} label ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
  PAID_FEATURES: {
    id: 'Pricing.experimentIPPMCopy.PaidFeatures',
    defaultMessage: 'Paid features in your survey',
    desc: {
      id: 'Pricing.experimentIPPMCopy.PaidFeatures',
      message: `${TYPE_DESCRIPTION} ${CATEGORY} label ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
};

export default IPPM_DRAFT_COPY;
